import React, { useState } from 'react';
import { Radio } from 'semantic-ui-react';
import styled from 'styled-components';
import { QuestionHeader, QuestionIndex, QuestionStatement } from '../../components';
import QuestionContainer from './QuestionContainer';

const Choice = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: #f6e9db;
  border: 1px solid #f6e9db;
  cursor: pointer;

  label {
    font-family: 'IBM Plex Sans';
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #2e2d29;
    cursor: pointer;
  }
  &.checked {
    background: #f9a44a;
    border: 1px solid #f9a44a;
    label {
      font-weight: 700;
      color: #ffffff;
    }
  }
  &.disabled {
    pointer-events: none;
  }
`;

const RadioWrapper = styled(Radio)`
  background: #f6e9db !important;
  border: 1px solid #f6e9db !important;
  margin-right: 15px !important;

  label:before {
    background: #f6e9db !important;
    width: 18px !important;
    height: 18px !important;
    border: 2px solid #2e2d29 !important;
    border-radius: 50% !important;
  }
  label:hover:before {
    border-color: #2e2d29 !important;
    background: #f6e9db !important;
  }

  &.checked {
    background: #f9a44a !important;
    border: 1px solid #f9a44a !important;
    font-weight: 700 !important;
    color: #ffffff !important;
    label:before {
      border-color: #ffffff !important;
      background: #f9a44a !important;
    }
    label:after {
      background-color: #ffffff !important;
      color: #ffffff !important;
      font-size: 12px;
      font-weight: normal;
      width: 18px !important;
      height: 18px !important;
    }
    label:focus::before {
      border-color: #ffffff !important;
      background: #f9a44a !important;
    }
  }
`;

const MultipleChoiceQuestion = ({ index, statement, options, disabled, onClick }) => {
  const [selected, setSelected] = useState(null);

  const handleSelect = option => {
    if (disabled) return;
    setSelected(option);
    onClick(option);
  };

  return (
    <QuestionContainer>
      <QuestionHeader>
        <QuestionIndex>{`Question ${index + 1}`}</QuestionIndex>
        <QuestionStatement>{statement}</QuestionStatement>
      </QuestionHeader>
      <div className="mt3">
        {options.map((option, i) => (
          <Choice
            key={i}
            className={`col-9 mt2 px3 py2 ${selected === option ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={() => handleSelect(option)}
          >
            <RadioWrapper
              name={`mc-${index}`}
              value={option}
              checked={selected === option}
              disabled={disabled}
              onChange={() => {}}
            />
            <label>{option}</label>
          </Choice>
        ))}
      </div>
    </QuestionContainer>
  );
};

export default MultipleChoiceQuestion;
